"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = exports.Form = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const layout_1 = require("./layout");
require("./Form.pc.css");
const Form = ({ testId, className, onSubmit, children }) => {
    return (react_1.default.createElement(layout_1.FormLayout, { className: (0, clsx_1.default)('_f63b6de7', '_16c2a9ff', '_pub-16c2a9ff', className), testId: testId, onSubmit: onSubmit }, children));
};
exports.Form = Form;
const Row = ({ className, v3, children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_118340e0', '_16c2a9ff', '_pub-16c2a9ff', { '_16c2a9ff_v3 _pub-16c2a9ff_v3 v3': v3 }, className) }, children));
};
exports.Row = Row;
//# sourceMappingURL=Form.js.map